// extracted by mini-css-extract-plugin
export default {"nin_template":"verify_nin_template__-PINy"};